document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.dropdown');
  if (!dropdowns.length) return;

  // Open dropdown
  document.querySelectorAll('.dropdown__placeholder').forEach((placeholder) => {
    placeholder.addEventListener('click', (event) => {
      const parent = event.target.closest('.dropdown');
      parent.classList.toggle('is-open');

      if (parent.classList.contains('dropdown--search')) {
        parent.querySelector('.dropdown__search-input').focus();
      }
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.dropdown').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('is-open');
        dropdown.querySelector('.dropdown__search-input')?.blur();
      }
    });
  });

  // Update single select dropdown
  const updateSingleSelect = (dropdown, selectedOption) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    placeholderText.innerHTML = selectedOption.innerHTML;
    placeholderText.dataset.ehrm = selectedOption.dataset.ehrm;
    dropdown.classList.remove('is-open');
  };

  // Update multi-select dropdown
  const updateMultiSelect = (dropdown, placeholderText, defaultPlaceholder, originalPlaceholder) => {
    setTimeout(() => {
      const selectedOptions = [...dropdown.querySelectorAll('.dropdown__list-inner input:checked')].map((input) =>
        input.nextElementSibling.innerHTML.trim(),
      );
      placeholderText.innerHTML =
        selectedOptions.length > 0 ? selectedOptions.join(', ') : originalPlaceholder || defaultPlaceholder;

      if (selectedOptions.length === 0) {
        dropdown.classList.remove('is-selected');
      }
    }, 50);
  };

  // Handle option selection
  document.querySelectorAll('.dropdown__list-option').forEach((option) => {
    option.addEventListener('click', (event) => {
      const dropdown = event.target.closest('.dropdown');
      const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
      const defaultPlaceholder = placeholderText.getAttribute('data-placeholder');
      const originalPlaceholder = placeholderText.getAttribute('data-original-placeholder');

      if (!dropdown.classList.contains('dropdown--multiselect')) {
        updateSingleSelect(dropdown, event.target);
      } else {
        updateMultiSelect(dropdown, placeholderText, defaultPlaceholder, originalPlaceholder);
      }

      dropdown.classList.add('is-selected');
    });
  });

  // Open specific dropdown based on URL hash
  const locationHash = window.location.hash.replace(/^#/, '');
  if (locationHash) {
    document.querySelectorAll(`#${locationHash}`).forEach((el) => {
      el.setAttribute('checked', 'true');
      const dropdown = el.closest('.dropdown');
      if (dropdown) {
        const optionLabel = el.parentElement.querySelector('.dropdown__list-option');
        dropdown.querySelector('.dropdown__placeholder').innerHTML = optionLabel.innerHTML;
      }
    });
  }

  // Dropdown search filtering
  document.querySelectorAll('.dropdown__search-input').forEach((input) => {
    input.addEventListener('input', () => {
      const searchValue = input.value.toLowerCase();
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-option')
        .forEach((option) => {
          const isVisible = option.innerHTML.toLowerCase().includes(searchValue);
          option.closest('.dropdown__list-item').style.display = isVisible ? 'block' : 'none';
        });
    });
  });

  // Reset search on outside click
  document.addEventListener('click', () => {
    document.querySelectorAll('.dropdown__search-input').forEach((input) => {
      input.value = '';
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-item')
        .forEach((item) => {
          item.style.display = 'block';
        });
    });
  });

  // On refresh set selected Locations/Categories on input
  document.querySelectorAll('.dropdown__list-item input:checked').forEach((option) => {
    const dropdown = option.closest('.dropdown');
    if (dropdown) {
      const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
      const defaultPlaceholder = placeholderText.getAttribute('data-placeholder');
      const originalPlaceholder = placeholderText.getAttribute('data-original-placeholder');
      updateMultiSelect(dropdown, placeholderText, defaultPlaceholder, originalPlaceholder);
      dropdown.classList.add('is-selected');
    }
  });
});
